import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import '@styles/global.sass';
import { ChatComponent } from './chatComponent';
import { ChatsHistoryComponent } from './chatsHistoryComponent';
import { useDispatch, useSelector } from 'react-redux';
import { setToken, setUserId } from '../store/rootDataSlice';
import { HeaderComponent } from "@components/headerComponent";
import { handleClickOutsideMenu } from "./themeHandlers";
import { getAccessToken } from '../api/apiApi';
const App = () => {
    const dispatch = useDispatch();
    const userId = useSelector((state) => state.rootData.userId);
    const token = useSelector((state) => state.rootData.token);
    const [mockup, setMockup] = React.useState(_jsx("div", { className: "loader", children: _jsx("svg", { viewBox: "0 0 100 100", children: _jsx("use", { xlinkHref: "#loaderThumb" }) }) }));
    function getAuthMockup() {
        return (_jsxs("div", { className: "no-auth-message", children: [_jsx("div", { className: "aiAssistantLogo", children: _jsx("svg", { viewBox: "0 0 100 100", children: _jsx("use", { xlinkHref: "#aiAssistantThumb" }) }) }), _jsx("p", { children: _jsxs(_Fragment, { children: ["No ", _jsx("u", { children: "userId" }), " and/or ", _jsx("u", { children: "token" }), " specified."] }) })] }));
    }
    useEffect(() => {
        async function fetchData() {
            const urlParams = new URLSearchParams(window.location.search);
            const userIdParam = urlParams.get('userId')?.toString() || null;
            const tokenParam = urlParams.get('token')?.toString() || null;
            if (!userIdParam || !tokenParam) {
                setMockup(getAuthMockup());
                return;
            }
            let accessToken = await getAccessToken(tokenParam, userIdParam);
            if (!accessToken) {
                setMockup(getAuthMockup());
                return;
            }
            dispatch(setUserId(userIdParam));
            dispatch(setToken(accessToken));
            setMockup(_jsxs("div", { onClick: handleClickOutsideMenu, children: [_jsx(HeaderComponent, {}), _jsx(ChatsHistoryComponent, {}), _jsx(ChatComponent, {})] }));
        }
        fetchData();
    }, [dispatch]);
    return mockup;
};
export default App;
